// import React from 'react'

// function Notes() {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default Notes


import React, { useEffect, useState } from 'react'
import { Badge, Container } from 'react-bootstrap'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomTable from '../Components/CustomTable/CustomTable'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAdminNotes } from '../hooks/notes'
import CustomViewImage from '../Components/CustomViewImage/CustomViewImage'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
function Notes() {
  const navigate = useNavigate();
    const dispatch=useDispatch();
          const  {list}  = useSelector((state) => state.notes);
          const [sourceImg, setSourceImg] = useState(null)
            const [modalShow, setModalShow] = useState(false);

const formatToOman = (dateString) => {
  const date = new Date(dateString);

  return {
    date: date.toLocaleDateString("en-OM", {
      timeZone: "Asia/Muscat",
    }),
    time: date.toLocaleTimeString("en-OM", {
      timeZone: "Asia/Muscat",
      hour: "2-digit",
      minute: "2-digit",
    }),
  };
};
  const downloadExcel = () => {
  if (!list || list.length === 0) return;

  const data = list.map((item) => {
    const formatted = formatToOman(item?.created_at);

    return {
      "اسم الوجبة": item?.category?.name,
      "اسم المستفيد": item?.trainer?.name,
      "تعليقي": item?.note,
      "التاريخ": formatted.date,
      "الوقت": formatted.time,
      "رابط الصورة": item?.image, // مهم عشان الصور متتحملش في excel
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Notes");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const fileData = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(fileData, `notes-${new Date().toISOString()}.xlsx`);
};
      useEffect(() => {
        dispatch(fetchAdminNotes())
        }, [dispatch])
  const customheader=<thead>
    <tr>
      <td><strong>الصورة</strong></td>
      <td><strong>اسم الوجبة</strong></td>
      <td><strong>اسم المستفيد</strong></td>
      <td><strong>تعليقي</strong></td>
            <td><strong>التاريخ</strong></td>
      <td><strong>الوقت</strong></td>
    </tr>
  </thead>

  const body=<tbody>
              {list?.map((item)=>{
                const formatted = formatToOman(item?.created_at);

return(
    <tr>
            <td><img src={item?.image}alt=''className='w-25' onClick={(e)=>{
              setSourceImg(item?.image)
              setModalShow(true)
            }}/></td>

      <td>{item?.category?.name}</td>
      <td>{item?.trainer?.name}</td>
      <td>{item?.note}</td>
        <td>{formatted.date}</td>
        <td>{formatted.time}</td>


    </tr>
)              })}

  
  </tbody>

  return (
    <div>
      <CustomViewImage
        show={modalShow}
        onHide={() => setModalShow(false)}
        src={sourceImg}
      />
    <AuthNavbar/>
      <Container>

                <CustomHeader
          title={"الالتحاق بالأكاديمية"}
          subtitle={"إدارة  مستفيدين نشطًا في برامج فنون الطهي"}
          downloadData={true}
          addData={false}
                    status={"student-notes"}
                              downloadFunction={downloadExcel}


        />
                <CustomTable
          fiteration={[]}
          currentData={25}
          allData={' 1,248  مستفيد'}
          customheader={customheader}
          status={"student"}
          body={body}

        />
        </Container>
    </div>
  )
}

export default Notes
